import React from 'react';
import { Button, Form } from 'react-bootstrap';

const CommonButtonWithInput = ({
  unitArray,
  clickAction,
  rowName,
  colName,
  indexName,
  value,
  isPara,
}) => {
  return (
    <div className={`mt-1 common-btn ${indexName}`}>
      {unitArray.map((item, index) => {
        return (
          <Button
            key={index}
            size="sm"
            className="btn-sm-customize"
            variant="outline-secondary"
            onClick={() => clickAction(rowName, colName, indexName, item)}
          >
            {item}
          </Button>
        );
      })}
      <Form.Control
        size="sm"
        type="text"
        placeholder="Type"
        style={{ width: '60px' }}
        value={value}
        onChange={(e) =>
          clickAction(
            rowName,
            colName,
            indexName,
            e.target.value,
            true,
          )
        }
      />
    </div>
  );
};
export default CommonButtonWithInput;
